export default __webpack_public_path__ + "static/media/CV-RJP.7337eceb.pdf";